import api from "../utils/axios/axiosConfig";

const authService = {
  impersonate: (userId) => api.post(`/auth/impersonate/${userId}`, {}),
  changePasswordForget: (data) => api.post("/auth/change-password-forget", data),
};

export default authService;
